import React from 'react';
import { Translate } from 'react-redux-i18n';
import Modal from '../../../common/modals/Modal';
import Button from '../../../common/Button';
import logo from '../../../../img/createAccount/envoi.svg';
import { getLinks } from '../../../../network/api/links';

type Props = {
  isOpen: boolean,
  closeModal: () => void;
  entity?: string;
};

function DoneModal(props: Props): JSX.Element {
  return (
    <Modal isOpen={props.isOpen} onClose={props.closeModal} className="almost-done-modal">
      <h3>
        <Translate value="END_FORM_CREATED.CREATION_TITLE" />
      </h3>
      <div className="information-text">
        <h5><Translate value="END_FORM_CREATED.CREATION_SUBTITLE" /></h5>
        <h5>{props.entity}</h5>
        <div>
          <img className="logo" src={logo} alt="logo" />
        </div>
        <span>
          <Translate className="" value="END_FORM_CREATED.INFORMATION_SUBTITLE" />
        </span>
      </div>
      <div className="button-container">
        <a
          aria-label="Se connecter"
          href={getLinks().connectionLink}
        >
          <Button
            type="primary"
            i18nKey="END_FORM.ACTION"
          />
        </a>
      </div>
    </Modal>
  );
}
export default DoneModal;
